import { motion } from "framer-motion";
import { FiCheck } from "react-icons/fi";

interface PricingCardProps {
  title: string;
  price: string;
  features: string[];
  delay: number;
}

const PricingCard = ({ title, price, features, delay }: PricingCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      className="bg-white rounded-xl shadow-lg p-8 flex flex-col h-full"
    >
      <h3 className="text-2xl font-bold text-blue-600 mb-4">{title}</h3>
      <div className="text-4xl font-bold mb-6">{price}</div>
      <ul className="flex-grow space-y-4 mb-8">
        {features.map((feature, index) => (
          <li key={index} className="flex items-center space-x-3">
            <FiCheck className="text-blue-600 flex-shrink-0" />
            <span className="text-gray-600">{feature}</span>
          </li>
        ))}
      </ul>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="w-full py-4 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
      >
        Select Plan
      </motion.button>
    </motion.div>
  );
};

export default PricingCard;
